<div class="popup marginBottomStyle" cdkDrag cdkDragRootElement=".cdk-overlay-pane"
    style="position: relative; overflow: hidden; height: 100%">

    <!-- Header -->
    <div cdkDragHandle>
        <label class="textColour">Import / Export Configuration</label>
        <span class="example-spacer"></span>
    </div>

    <!-- Body -->
    <div style=" overflow: hidden">
        <div style=" overflow: auto">

            <form [formGroup]="importExportForm" novalidate style="margin-bottom: 3em">

                <div class="container">

                    <div style="max-width: 0; max-height: 0; overflow: hidden">
                        <input autofocus />
                    </div>

                    <!-- Module / Screen -->
                    <div class="row topRowMargins">
                        <div class="col-lg-1"></div>
                        <div class="col-lg-10">

                            <mat-form-field appearance="outline" style="width: 100%;">
                                <mat-label>Module / Screen </mat-label>
                                <mat-select formControlName="type" (selectionChange)="onTypeChange($event)">
                                    <mat-option value="module">Module</mat-option>
                                    <mat-option value="screen">Screen</mat-option>
                                </mat-select>
                            </mat-form-field>

                        </div>
                        <div class="col-lg-1"></div>
                    </div>

                    <!-- Name -->
                    <div class="row topRowMargins">
                        <div class="col-lg-1"></div>
                        <div class="col-lg-10">

                            <mat-form-field appearance="outline" style="width: 100%;">
                                <mat-label>Module / Screen Name </mat-label>
                                <mat-select formControlName="name" (selectionChange)="onNameChange($event)">
                                    <mat-option *ngFor="let item of nameList" [value]="item">
                                        {{item.screenId}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </div>
                        <div class="col-lg-1"></div>
                    </div>

                    <!-- Action -->
                    <div class="row topRowMargins">
                        <div class="col-lg-1"></div>
                        <!-- <div class="col-lg-10">

                            <mat-form-field appearance="outline" style="width: 100%;">
                                <mat-label>Action *</mat-label>
                                <mat-select formControlName="action" (selectionChange)="onDownloadUpload($event)">
                                    <mat-option value="upload">Upload</mat-option>
                                    <mat-option value="download">Download</mat-option>
                                </mat-select>
                            </mat-form-field>

                        </div> -->
                        <div class="col-lg-10"> 
                        <button *ngIf="actionDownload" class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                            [style.background-color]="backgroundColorButton" [style.min-width.px]="90"
                            style="font-size: 12px; padding: 0; height: 32px;" id="103" title="Export Data" (click)="onDownload()">
                            Export
                            <em class="fas fa-upload" style="font-size: 12px; padding: 0 5px;"></em>
                        </button>
                        <button  *ngIf="actionDownload" class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                            [style.background-color]="backgroundColorButton" [style.min-width.px]="90"
                            style="font-size: 12px; padding:0; height: 32px;" id="102" title="Import Data" (click)="onUpload()">
                            Import
                            <em class="fas fa-download" style="font-size: 12px; padding: 0 5px;"></em>
                        </button>
                        </div>
                        <div class="col-lg-1"></div>
                    </div>

                </div>
            </form>
        </div>
    </div>

    <!-- Footer -->
    <div class="row mb-1 topRowMargins" style="position:sticky;left:0;bottom:0;width:100%">
        <div class="col-lg text-center">

            <div style="text-align: end">

                <!-- Submit -->
                <!-- <button type="button" (click)="submit()"
                    class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    style="padding-left:1.2rem;padding-right: 1.2rem" [style.background-color]="backgroundColorButton">

                    Submit
                </button> -->

                <!-- Cancel -->
                <!-- <button type="button" (click)="closeFunction()"
                    class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    style="padding-left:1.2rem;padding-right: 1.2rem" [style.border-color]="backgroundColorButton">

                    Cancel
                </button> -->

                <app-common-button
                    label="Cancel"
                    title="Cancel "  
                    [buttonId]="1111"
                    variant="cancel"
                    width="110px"
                    [critical]="false"
                    (clicked)="closeFunction()"
                    >
                </app-common-button>

            </div>

        </div>
    </div>

</div>